import React, { forwardRef } from 'react';
import { IconButton, Button, Icon } from '@picsio/ui';
import { Close, Infobox } from '@picsio/icons';
import { func, shape, string } from 'prop-types';
import cn from 'classnames';
import hintStyles from './styles.module.scss';

const CatalogBanner = forwardRef((props, ref) => {
  const {
    onClose, text, buttonText, styles = {}, onClick, icon = <Infobox />, isWarning = false,
  } = props;

  return (
    <div
      className={hintStyles.banner}
      ref={ref}
      style={styles}
    >
      <Icon size="lg" className={cn(hintStyles.bannerIcon, { [hintStyles.warning]: isWarning })}>
        {icon}
      </Icon>
      <div className={hintStyles.bannerText}>{text}</div>
      <Button
        onClick={onClick}
        className={hintStyles.bannerActionText}
        type="text"
        color="secondary"
        id="applyBestMatch"
      >
        {buttonText}
      </Button>
      <IconButton id="closeApplyBestMatch" buttonSize="lg" size="xl" className={hintStyles.bannerClose} onClick={onClose}>
        <Close />
      </IconButton>
    </div>
  );
});

CatalogBanner.propTypes = {
  icon: func.isRequired,
  onClose: func.isRequired,
  text: string.isRequired,
  buttonText: string.isRequired,
  styles: shape({}),
  onClick: func.isRequired,
};

export default CatalogBanner;
